import React from 'react';

export default ({ children, classes, interactive, onClick }) => {
  return (  
    interactive
    ? <button role="button" className={classes} onClick={onClick}>{children}</button>
    : <div className={classes}>{children}</div>
  );
};